/**
 * @generated SignedSource<<9303f63ea2dd4fc550494d89739549b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type communityShell_club$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"communitySidebarFragment" | "portals_club" | "sidebarPreview">;
  readonly " $fragmentType": "communityShell_club";
};
export type communityShell_club$key = {
  readonly " $data"?: communityShell_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"communityShell_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "communityShell_club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "communitySidebarFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "sidebarPreview"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "portals_club"
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "bb35795125a4ec5568897f4c84355e82";

export default node;
